import * as _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import { ActionCd } from '@xpo-ltl/sdk-common';
import { DsrActivity } from '@xpo-ltl/sdk-linehaulpayform';
import { addActivityAction, deleteActivityAction, moveActivityAction, updateActivityAction } from './activities.actions';
import { AppStateUtils } from '../app-state.utils';

export const initialState: DsrActivity[] = [];

export const ActivitiesReducer = createReducer(
  initialState,
  on(addActivityAction, (state, { activity }) => {
    const newActivity = _.cloneDeep(activity) as DsrActivity;
    newActivity.listActionCd = ActionCd.ADD;
    newActivity.statusCd = 'New';
    return [...state, newActivity];
  }),
  on(updateActivityAction, (state, { activity }) => {
    const actvtySequenceNbr = _.get(activity, 'actvtySequenceNbr', undefined);
    const existing: DsrActivity = AppStateUtils.getActivityFromState(state, actvtySequenceNbr);
    if (!existing) {
      throw new Error(`ACTIVITY '${actvtySequenceNbr}' NOT FOUND`);
    }

    if (existing.listActionCd === ActionCd.DELETE) {
      throw new Error(`ACTIVITY '${actvtySequenceNbr}' IS DELETED`);
    }

    _.forOwn(activity, (value, key) => {
      _.set(existing, key, value);
    });

    if (existing.listActionCd !== ActionCd.ADD) {
      _.set(existing, 'listActionCd', ActionCd.UPDATE);
    }

    return state;
  }),
  on(deleteActivityAction, (state, { actvtySequenceNbr }) => {
    const existing = AppStateUtils.findActivityInState(state, actvtySequenceNbr);
    if (existing && existing.listActionCd !== ActionCd.DELETE) {
      if (existing.listActionCd === ActionCd.ADD) {
        // remove newly added activity from list
        _.pull(state, existing);
      } else {
        // mark exisiting activity as deleted
        existing.listActionCd = ActionCd.DELETE;
      }
      state = [...state];
      return state;
    } else {
      // activity didn't exist in this Payform, so nothing to do
      return state;
    }
  }),
  on(moveActivityAction, (state, { actvtySequenceNbr, schSequenceNbr }) => {
    if (AppStateUtils.findActivityInState(state, actvtySequenceNbr)) {
      const existing = _.first(_.remove(state, item => item.actvtySequenceNbr === actvtySequenceNbr)) as DsrActivity;
      existing.schSequenceNbr = schSequenceNbr ? schSequenceNbr : undefined;
      if (existing.listActionCd !== ActionCd.DELETE && existing.listActionCd !== ActionCd.ADD) {
        // Activity is not new, and not marked for delete, so mark it for Update
        existing.listActionCd = ActionCd.UPDATE;
      }
      state = [...state, existing];
      return state;
    } else {
      // activity didn't exist in this Payform, so nothing to do
      return state;
    }
  })
);
